export const UserItemMockData = {
  id: '6fc728fa-8be4-eb11-b563-000d3a223e1c',
  displayName: 'Mock User',
  email: 'mockuser@gmail.com',
  createdOn: '0001-01-01T00:00:00+00:00',
  modifiedOn: '0001-01-01T00:00:00+00:00',
  groups: [
    {
      groupId: '1acf7c64-2228-ec11-981f-000d3a223e22',
      name: 'Mock Group',
      organizationId: '6c40c6c4-7405-4126-a60d-102f29fd2329',
      organizationName: 'Mock User Organization',
    },
  ],
  organizations: [
    {
      organizationId: '6c40c6c4-7405-4126-a60d-102f29fd2329',
      organizationDisplayName: 'Mock User Organization',
    },
  ],
} as any;
